/**
 * Local calendar YYYY-MM-DD (avoid UTC midnight shifts from toISOString).
 */
export function toLocalYyyyMmDd(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/** First 10 chars as YYYY-MM-DD from API deal field. */
export function dealClosingDayIso(deal: {
  closingDate?: string | null;
  closing_date?: string | null;
} | null | undefined): string | null {
  const raw = deal?.closingDate ?? deal?.closing_date;
  if (raw == null || String(raw).trim() === "") return null;
  const s = String(raw).trim().slice(0, 10);
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  return null;
}

/** Planned close is strictly before today's local calendar date. */
export function isClosingDateOverdue(day: string | null | undefined): boolean {
  if (day == null || day === "") return false;
  const today = toLocalYyyyMmDd(new Date());
  return day < today;
}

/**
 * Tailwind classes for closing date text: red if overdue (strictly before today),
 * otherwise neutral (today or future, or unknown).
 */
export function closingDateDisplayClass(day: string | null | undefined): string {
  if (day == null || day === "") return "text-muted-foreground";
  return isClosingDateOverdue(day)
    ? "text-destructive"
    : "text-muted-foreground";
}

export function dealIsClosingOverdue(deal: {
  closingDate?: string | null;
  closing_date?: string | null;
} | null | undefined): boolean {
  const day = dealClosingDayIso(deal);
  return day != null && isClosingDateOverdue(day);
}
